import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getStores(page, limit) {
  const response = await sendRequest(page, limit)
  const parsedResponse = parseResponse(response, Formatter)
  return parsedResponse
}

async function sendRequest(page, limit) {
  const url = `${urls.getStores}?limit=${limit}&page=${page}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalStores(rawData)

    return {
      statusCode: 200,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getStores }
